import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SessionInfoSingleton } from "../data/singleton/session-info.singleton";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { formatMessage } from "src/app/shared/utils/message.util";
import { environment } from "src/environments/environment";
import { AlertMessage } from "../constants/messages/alert-message";

/**
 * パス「/partitions」以下のAPIに関するクラス
 */
@Injectable({
  providedIn: "root",
})
export class PartitionsApi {
  private readonly ERR_ALERT_TARGET_NAME = "区画情報";

  /**
   * コンストラクタ
   */
  constructor(
    private httpClient: HttpClient,
    private sessionInfoSingleton: SessionInfoSingleton
  ) {}

  /** GET */

  /** POST */
  /**
   * 区画情報の追加
   * - APIパス：/partitions/partition_info
   * @param params 内容
   * @returns Observable<Object>型のレスポンス
   */
  createParititon(params: HttpParams): Observable<Object> {
    const url = `${environment.apiUrl}/partitions/partition_info`;
    const errorMessage = formatMessage(AlertMessage.FAILED_CREATE_ACTION, {
      target: this.ERR_ALERT_TARGET_NAME,
    });

    return this.httpClient
      .post(url, params, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }

  /**
   * テナントの新規作成
   * - APIパス：/partitions/tenants
   * @param params 内容
   * @returns Observable<Object>型のレスポンス
   */
  createTenants(params: HttpParams): Observable<Object> {
    const url = `${environment.apiUrl}/partitions/tenants`;
    const errorMessage = formatMessage(AlertMessage.FAILED_CREATE_ACTION, {
      target: this.ERR_ALERT_TARGET_NAME,
    });

    return this.httpClient
      .post(url, params, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }

  /** PUT,PATCH */
  /**
   * 区画削除
   * - APIパス:/partitions/partition_info/0/${partitionId}
   * @param partitionId 区画ID
   * @param params 更新内容
   * @returns Observable<Object>型のレスポンス
   */
  deletePartition(partitionId: string, params: HttpParams): Observable<Object> {
    const url = `${environment.apiUrl}/partitions/partition_info/0/${partitionId}`;
    const errorMessage = formatMessage(AlertMessage.FAILED_DELETE_ACTION, {
      target: this.ERR_ALERT_TARGET_NAME,
    });

    return this.httpClient
      .patch(url, params, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }

  /**
   * 区画更新
   * - APIパス:/partitions/partition_info/1/${partitionId}
   * @param partitionId 区画ID
   * @param params 更新内容
   * @returns Observable<Object>型のレスポンス
   */
  updatePartition(partitionId: string, params: HttpParams): Observable<Object> {
    const url = `${environment.apiUrl}/partitions/partition_info/1/${partitionId}`;
    const errorMessage = formatMessage(AlertMessage.FAILED_UPDATE_ACTION, {
      target: this.ERR_ALERT_TARGET_NAME,
    });

    return this.httpClient
      .patch(url, params, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }

  /**
   * 区画に紐付くテナントの情報変更
   * - テナント解約など
   * - APIパス：/partitions/${partitionId}/tenants/${tenantId}
   * @param partitionId 区画ID
   * @param tenantId テナントID
   * @param params 更新内容
   * @returns Observable<Object>型のレスポンス
   */
  cancelledAtToPartitionsTenants(
    partitionId: string,
    tenantId: string,
    params: HttpParams
  ): Observable<Object> {
    const url = `${environment.apiUrl}/partitions/${partitionId}/tenants/${tenantId}`;
    const errorMessage = formatMessage(AlertMessage.FAILED_UPDATE_ACTION, {
      target: "区画に紐付くテナントの情報",
    });

    return this.httpClient
      .patch(url, params, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }

  /**
   * カード表示フラグの更新
   * - APIパス：/partitions/${partitionId}/is_card_display
   * @param partitionId 区画ID
   * @param params 更新内容
   * @returns Observable<Object>型のレスポンス
   */
  updateCardDisplayFlag(
    partitionId: string,
    params: HttpParams
  ): Observable<Object> {
    const url = `${environment.apiUrl}/partitions/${partitionId}/is_card_display`;
    const errorMessage = formatMessage(AlertMessage.FAILED_UPDATE_ACTION, {
      target: "カード表示フラグ",
    });

    return this.httpClient
      .patch(url, params, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }
}
